import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { UpdatePin } from '../../../state/actions/merchant.actions';
import { StopLoading } from '../../../state/actions/general.actions';
import { CustomValidators } from '../../../shared/validators/customValidators';
import { AppState } from '../../../state/appState';
import { Observable } from 'rxjs';
import { GatewayConfigModel } from '../../../shared/services/gateway-config/gatewayConfig.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-account-change-pin',
  templateUrl: './account-change-pin.component.html',
  styleUrls: ['./account-change-pin.component.scss'],
})
export class AccountChangePinComponent implements OnInit {
  @Select(AppState.gatewayConfig$)
  gatewayConfig$: Observable<GatewayConfigModel>;
  public passwordForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private store: Store) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.gatewayConfig$.pipe(take(1)).subscribe(cfg => {
      this.passwordForm = this.fb.group(
        {
          password: new UntypedFormControl('', [Validators.required]),
          newPassword: new UntypedFormControl('', [
            Validators.required,
            CustomValidators.passwordSecurity(cfg.merchant.passwordSecurity),
          ]),
          newPasswordRepeat: new UntypedFormControl('', [Validators.required]),
        },
        {
          validator: CustomValidators.checkPasswords,
        }
      );
    });
  }

  submitPinChange(): void {
    if (!this.passwordForm.valid) { return; }

    const { password, newPassword } = this.passwordForm.getRawValue();
    this.store.dispatch(new UpdatePin(password, newPassword)).subscribe(
      () => {},
      error => {
        this.passwordForm.reset();
        if (error && error.status === 401) {
          this.passwordForm.setErrors({ unauthorized: true });
        } else {
          this.passwordForm.setErrors({ unknown: true });
        }
        this.store.dispatch(new StopLoading());
      }
    );
  }
}
